'use client';

import QuillEditorV2 from './quill-editor-v2';
import QuillEditorWrapper from './quill-editor-wrapper';
import RenderQuillContent from './render-quill-content';

const CustomQuillEditor = {
    /**
     * @deprecated
     * Đổi qua sử dụng v2, thích thì sài nhưng hết được maintain, lỗi banh xác
     *  */
    Root: QuillEditorWrapper,

    /**Sử dụng react-quill, xịn & dễ sài hơn */
    V2: QuillEditorV2,

    RenderContent: RenderQuillContent,
    name: 'CustomQuillEditor',
};

export type * from './quill-editor';
export type * from './quill-editor-v2';
export default CustomQuillEditor;
